import { useState, useEffect, useRef } from 'react';
import { useAuth, login, validateLoginForm } from 'src/utils';
import '../profile.css';
import { Box, Button, TextFieldInput, Loader, Divider, Typography, Stack } from 'src/components';
import { ProfileViewHeader, GoogleAuth, AppleAuth } from '../index';
import { useIsMobile } from 'src/hooks';

export default function Login({handleCurrentViewChange, handleSuccess}) {
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});

    const { loginUser } = useAuth();
    const isMobile = useIsMobile();
    const timer = useRef();

    useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMsg("");
        setFieldErrors({});

        document.activeElement.blur();

        const { errors, isValid } = validateLoginForm(email, password);
        if (!isValid) {
            setFieldErrors(errors);
            setLoading(false);
            return;
        }
        
        timer.current = window.setTimeout(async () => {
            try {
                const res = await login(email, password);
                loginUser(res.token, res.refreshToken); 
                handleSuccess("Login successful!");
                handleCurrentViewChange("AccountSummary");
            } catch (err) {
                setErrorMsg(err.response?.data || 'Login failed. Please contact support');
            } finally {
                setLoading(false);
            }
        }, 500); 
    };

    return (
        <div>
            <ProfileViewHeader title="Log In" subtitle="Enter your details below" handleCurrentViewChange={handleCurrentViewChange} backTo="NotLoggedIn" alternateActionText="Don't have an account?" alternateActionPage="Register" />

            <Box component="form" noValidate onSubmit={handleLogin} sx={{ mb: 1 }}>

                <TextFieldInput 
                    id="email" 
                    label="Email Address" 
                    type="email" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={!!fieldErrors.email}
                    helperText={fieldErrors.email}/>

                <TextFieldInput 
                    id="password" 
                    label="Password" 
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!fieldErrors.password}
                    helperText={fieldErrors.password}/>

                {errorMsg && (
                    <Typography variant="body3" color="error">{errorMsg}</Typography>
                )}

                {/* <div className="form-break forgot-password">
                    <Link aria-disabled className="link" variant="body2" onClick={() => handleCurrentViewChange("ForgotPassword")} >
                        Forgot password?
                    </Link>                    
                </div>     */}


                <Stack spacing={isMobile ? 2 : 1} mt={2} sx={{width: '100%'}}>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        className="submit-button button"
                        disabled={loading}>
                        Login
                    </Button>

                    <Divider /> 

                    <GoogleAuth setLoading={setLoading} handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess} />

                    <AppleAuth setLoading={setLoading} handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess} />

                </Stack>

            </Box>

            {loading && <Loader fullscreen={isMobile} />}

        </div>
    );
}
